import React, { Component } from "react";

class HelpCenter extends Component {
  render() {
    return (
      <div className="flex-center-center" style={{ height: "500px" }}>
        <h3>Help Center</h3>
      </div>
    );
  }
}

export default HelpCenter;
